import { render, staticRenderFns } from "./employeePhoto.vue?vue&type=template&id=6c002e60&"
import script from "./employeePhoto.vue?vue&type=script&lang=js&"
export * from "./employeePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports